export default "__VITE_ASSET__bdfpoK1C__"